export default "__VITE_ASSET__BrHuCGiz__"